module.exports = __webpack_public_path__ + "img/23_103.2327a27d.png";